import { render } from "./DatePickerDay.vue?vue&type=template&id=16382514"
import script from "./DatePickerDay.vue?vue&type=script&lang=ts"
export * from "./DatePickerDay.vue?vue&type=script&lang=ts"
script.render = render

export default script